module.exports = __webpack_public_path__ + "static/media/chevron-down.be41a57c.svg";